import { loginConstants } from './constants/loginConstants'

const loginGetDetail = (loginInput: any) => {
	return {
		type: loginConstants.LoginGetDetailRequest,
		input: loginInput
	};
};

const logoutGetDetail = () => {
	return {
		type: loginConstants.LogoutGetDetailRequest,

	};
};

const forgotPasswordReset = (input: any) => {
	return {
		type: loginConstants.ForgotPasswordChangeRequest,
		input: input
	};
};

const forgotPasswordRequest = (input: any) => {
	return {
		type: loginConstants.ForgotPasswordRequest,
		input: input
	};
};

const forgotPasswordCheckToken = (token) => {
	return {
		type: loginConstants.ForgotPasswordCheckTokenRequest,
		token: token
	};
};

const frontAppCheckToken = (token) => {
	return {
		type: loginConstants.FrontAppCheckTokenRequest,
		token: token
	}
}

const getUserByRefreshToken = (token) => {
	return {
		type: loginConstants.GetUserByRefreshTokenRequest,
		token: token
	}
};

export const loginAction = {
	loginGetDetail,
	logoutGetDetail,
	forgotPasswordRequest,
	forgotPasswordReset,
	forgotPasswordCheckToken,
	frontAppCheckToken,
	getUserByRefreshToken
}